export { default as MAP_STYLES } from './MapStyles';
export const DEFAULT_ZOOM = 5;
export const MAX_ZOOM = 16;
export const MIN_ZOOM = 4;
export const DEFAULT_CENTER = { lat: 38.5097343, lng: -98.5556199 };
export const MIN_WINDOW_WIDTH = 768;
